var map = {
	"./10_nuts.png": 2502,
	"./1drink_12beer.png": 2503,
	"./1serving_8ounces.png": 2504,
	"./1serving_8ounces2.png": 2505,
	"./1serving_8ounces3.png": 2506,
	"./1serving_8ounces4.png": 2507,
	"./1serving_8ounces5.png": 2508,
	"./8ounces_1glass.png": 2509,
	"./can_1.png": 2510,
	"./can_2.png": 2511,
	"./can_3.png": 2512,
	"./cup.png": 2513,
	"./dried_serving_1/4cup.png": 2514,
	"./dried_serving_1:4cup.png": 2515,
	"./fresh_serving_1cup.png": 2516,
	"./glass_1.png": 2517,
	"./glass_2.png": 2518,
	"./golfball.png": 2519,
	"./halfthumb.png": 2520,
	"./hand_1.png": 2521,
	"./hand_2.png": 2522,
	"./hand_3.png": 2523,
	"./hand_4.png": 2524,
	"./hand_5.png": 2525,
	"./how.png": 861,
	"./serving_1/2cup.png": 2526,
	"./serving_1:2cup.png": 2527,
	"./serving_1tbsp.png": 2528,
	"./serving_3/4ounces.png": 2529,
	"./serving_3:4ounces.png": 2530,
	"./thumbx2.png": 2531,
	"./usda.png": 2532,
	"./vegetables_1cup.png": 2533,
	"./what.png": 859,
	"./wholethumb.png": 2534,
	"./why.png": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2501;